import {delegate} from './events';

export default function () {
    var fileFields = document.querySelectorAll('.form__field--type-file');
    if (!fileFields.length) {
        return;
    }

    Array.prototype.forEach.call(fileFields, function (field) {
        var label = field.querySelector('label');

        var filename = document.createElement('span');
        filename.classList.add('form__filename');
        filename.classList.add('form__filename--empty');
        filename.classList.add('print-off');

        (function (node) {
            filename._i18n = JSON.parse(node.getAttribute('data-form-file-i18n'));
        })(field.closest('[data-form-file-i18n]'));

        filename.innerText = filename._i18n.browse;

        label.insertAdjacentElement('beforeend', filename);
        field.querySelector('input[type="file"]')._filename = filename;
    });

    document.addEventListener('change', delegate('.form__field--type-file input[type="file"]', function () {
        var input = this;
        var info = /([^/\\]+)$/.exec(input.value);
        input._filename.innerText = info ? info[1] : input._filename.getAttribute('data-label');
        input._filename.classList.toggle('form__filename--empty', !info);
    }));
}